// Copyright 2025, University of Maryland, All Rights Reserved

export type CacheStatus = 'idle' | 'queued' | 'refreshing' | 'error';

export interface CacheRecord {
  connectorId: string;
  cacheId: string;
  schedule: string | null;
  status: CacheStatus;
  lastRefreshAt: string | null;
  itemCount: number;
  itemsUpdated: number;
  jobId: string | null;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ConnectorRecord {
  connectorId: string;
  name: string;
  description: string;
  caches: CacheRecord[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateConnectorRequest {
  connectorId: string;
  name: string;
  description?: string;
}

export interface CreateCacheRequest {
  cacheId: string;
  schedule?: string | null;
}

export interface UpdateCacheRequest {
  schedule?: string | null;
}

export interface RefreshResponse {
  connectorId: string;
  cacheId: string;
  jobId: string | null;
  status: string;
}

export interface SubscriptionRecord {
  connectorId: string;
  cacheId: string;
  orgId: string;
  wsId: string;
  pipelineId: string | null;
  lastSyncedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSubscriptionRequest {
  orgId: string;
  wsId: string;
  pipelineId?: string | null;
}

export interface UpdateSubscriptionRequest {
  pipelineId?: string | null;
}

export const SCHEDULE_OPTIONS = [
  { value: '', label: 'Ad-hoc only' },
  { value: 'every_30_minutes', label: 'Every 30 Minutes' },
  { value: 'hourly', label: 'Every Hour' },
  { value: 'every_6_hours', label: 'Every 6 Hours' },
  { value: 'every_12_hours', label: 'Every 12 Hours' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
] as const;
